// extracted by mini-css-extract-plugin
export default {"container":"_9-EvD","imgWrapper":"CgBfR","bpImage":"ZalzB","label":"_2UkmH","adPageContainer":"l53Il","listPageContainer":"_3ss39"};